export enum SpotCheckResultStatus {
	ISSUE = 'ISSUE',
	TIP = 'TIP',
	PASSED = 'PASSED',
	IGNORED = 'IGNORED',
}
